/** Hostnames allowed by Umami data-domains (exact match on window.location.hostname). */
export const UMAMI_TRACKING_DOMAINS = [
  "interactggz.nl",
  "portal.interactggz.nl",
  "staging.portal.interactggz.nl",
  "emdr.portal.interactggz.nl",
  "emdr.staging.portal.interactggz.nl",
  "context-driehoek.portal.interactggz.nl",
  "context-driehoek.staging.portal.interactggz.nl",
  "act-avontuur.portal.interactggz.nl",
  "act-avontuur.staging.portal.interactggz.nl",
  "bloom.portal.interactggz.nl",
  "bloom.staging.portal.interactggz.nl",
].join(",");
